import * as actionTypes from '../types/adminActs';

export function getActs(payload) {
  return {
    type: actionTypes.GET_ACTS,
    payload
  };
}

export function getActsSuccess(payload) {
  return {
    type: actionTypes.GET_ACTS_SUCCESS,
    payload
  };
}

export function getActsFail(payload) {
  return {
    type: actionTypes.GET_ACTS_FAIL,
    payload
  };
}

export function signActs(payload) {
  return {
    type: actionTypes.SIGN_ACTS,
    payload
  };
}

export function signActsSuccess(payload) {
  return {
    type: actionTypes.SIGN_ACTS_SUCCESS,
    payload
  };
}

export function signActsFail(payload) {
  return {
    type: actionTypes.SIGN_ACTS_FAIL,
    payload
  };
}
